module.exports = __webpack_public_path__ + "img/layer-disabled.cc6206c6.svg";